export default __webpack_public_path__ + "static/media/01.4a996528.jpg";